export default __webpack_public_path__ + "static/cicJdpgN-fbafda92b3eb395c691154e5e12b6672.svg";